import { Injectable, inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ToastService } from '../../shared/services/toast.service';

/**
 * Respuesta de API con estado explícito (ej. 200 con estado "nok").
 */
interface RespuestaConEstado {
  estado?: string;
  error?: string;
  data?: unknown;
}

/**
 * Interceptor HTTP que detecta respuestas con status 200 y cuerpo con estado "nok".
 * Muestra un toast con el mensaje de error para que el usuario lo vea en cualquier endpoint.
 */
@Injectable()
export class ApiNokInterceptor implements HttpInterceptor {
  private readonly toastService = inject(ToastService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      tap((event) => {
        if (event instanceof HttpResponse && event.status === 200) {
          const body = event.body as RespuestaConEstado | null;
          if (
            body &&
            typeof body === 'object' &&
            (body as RespuestaConEstado).estado === 'nok' &&
            typeof (body as RespuestaConEstado).error === 'string'
          ) {
            const mensaje = (body as RespuestaConEstado).error!;
            this.toastService.mostrar(mensaje, 'error');
          }
        }
      })
    );
  }
}
